import React, { useState } from 'react';
import SharedInput from './SharedInput';
import SharedButton from './SharedButton';

const ImageUploader = ({ label, imageUrl, onImageUrlChange, onFileChange }) => {
  const [uploadMethod, setUploadMethod] = useState('url'); // 'url' or 'file'

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onFileChange(reader.result); // Pass base64 string or data URL
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="mb-4 p-4 border border-gray-300 rounded-lg bg-gray-50">
      <label className="block text-black text-sm font-bold mb-2">{label}</label>
      <div className="flex space-x-4 mb-4">
        <label className="inline-flex items-center">
          <input
            type="radio"
            value="url"
            checked={uploadMethod === 'url'}
            onChange={() => setUploadMethod('url')}
            className="form-radio h-4 w-4 text-[#961914]"
          />
          <span className="ml-2 text-black">Desde URL</span>
        </label>
        <label className="inline-flex items-center">
          <input
            type="radio"
            value="file"
            checked={uploadMethod === 'file'}
            onChange={() => setUploadMethod('file')}
            className="form-radio h-4 w-4 text-[#961914]"
          />
          <span className="ml-2 text-black">Subir Archivo</span>
        </label>
      </div>

      {uploadMethod === 'url' ? (
        <SharedInput
          label="URL de la Imagen"
          value={imageUrl}
          onChange={(e) => onImageUrlChange(e.target.value)}
          placeholder="Ej: https://ejemplo.com/imagen.jpg"
        />
      ) : (
        <div className="mb-4">
          <label className="block text-black text-sm font-bold mb-2">Seleccionar Archivo</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white text-black focus:outline-none focus:ring-2 focus:ring-[#961914]"
          />
        </div>
      )}

      {imageUrl && (
        <div className="mt-4">
          <p className="text-black text-sm mb-2">Vista previa:</p>
          <img src={imageUrl} alt="Vista previa" className="max-h-32 max-w-full object-contain border border-gray-300 rounded-lg p-2" />
        </div>
      )}
    </div>
  );
};

export default ImageUploader;